import type { CategoriesApi } from "@/v2/api/metadata/categories";
import type { SportsApi } from "@/v2/api/metadata/sports";
import type { BackofficeContext } from "@/v2/framework/context/types";
import { createAddDialog } from "./add";
import { createDeleteDialog } from "./delete";
import { createEditDialog } from "./edit";

export function createDialogs(options: {
  ctx: BackofficeContext;
  categoriesApi: CategoriesApi;
  sportsApi: SportsApi;
}) {
  return {
    add: createAddDialog(options),
    delete: createDeleteDialog(options),
    edit: createEditDialog(options),
  };
}
